import React from 'react';
import classnames from 'classnames'
import { Form, Formik } from 'formik';
import Tooltip from '../utilities/Tooltip'
import parse from 'html-react-parser';
import { HR } from '../render-helpers/Hr';
import Modal from "react-modal";
import { countCarbonReduction, formatDateDisplay, getFormatTier, getOldDays, shortFormBytes, shortFormEmissionNumber } from './customFunctions';
import Skeleton from '../../helpers/Skeleton';
import Spinner from '../utilities/Spinner'
import DatePicker from 'react-datepicker';
import { getDeviceName } from '../../helpers/devices';
import { confirmAlert } from 'react-confirm-alert';
import QrPreviewEmail from '../audiences/contextual/build-ads/extras/Qr-preview-email';
import { AnimatedNumber } from './customAnimations';
import { addonDataEmissions, renderGaugeData } from '../creative/report/reports/helpers';
import { ImageModal } from '../render-helpers';
import CustomEchart from '../echart';

const CustomInput = React.forwardRef(({ value, onClick, disabled }, ref) => {
    return (
        <div className="bb-single-datepicker">
            <div className={classnames('date-picker-bb-button bb-button font-weight-bold align-self-end mb-2 mr-2 custom-button', disabled ? "disabled" : "")} onClick={onClick} ref={ref}>
                <i className='fas fa-calendar-alt'></i>
            </div>
            <div className={classnames("form-control bb-date-picker cursor-pointer", disabled ? "disabled" : "")} onClick={onClick} ref={ref}>
                {value ? value : "Choose Date"}
            </div>
        </div>
    )
});

export const renderEditForm = (label, value, loading = false, additionalValue = "", component = null) => {
    return (
        <div className="form-row col-md-12 mb-3">
            <label className="bb-form-input-label col-sm-12 col-md-3">{label}</label>
            <div className="col-sm-12 col-md-9 d-flex justify-content-between">
                <div className="bb-form-input_color">
                    {loading ? <Skeleton height="12" /> : (value || "-")}
                    {additionalValue && <span className='bb-color_disabled ml-1'>{additionalValue}</span>}
                </div>
                {component}
            </div>
        </div>
    )
}
export const gpRenderDatePicker = (name, label, onChange, selected, min = null, maxDate = "") => {
    return (
        <div className='form-row col-md-12 mb-4'>
            <label className="mb-1 bb-form-input-label col-sm-12 col-md-3 pt-2">{label}</label>
            <div className="col-sm-12 col-md-6">
                <DatePicker
                    autoComplete="off"
                    dateFormat="yyyy-MM-dd"
                    selected={selected}
                    maxDate={maxDate}
                    minDate={min}
                    dropdownMode="select"
                    onChange={(date) => { onChange(date) }}
                    name={name}
                    placeholderText={"Choose Date"}
                    className="form-control bb-date-picker"
                    customInput={<CustomInput />}
                />
            </div>
        </div>
    )
}

export const renderReportCard = (header, content, info, suffix = parse("</span>mt CO<sub>2</sub>"), className) => {
    return <div className={classnames("d-flex flex-column flex-wrap  summary-card emission-card", className)}>
        <div className="d-flex justify-content-between">
            <h3 className="header-font bb-body-txt d-flex col-12 justify-content-between p-0">{header}
                {info ? <Tooltip default_id={info} arrowColor="#4DADC5" tooltipClassName="bb-tooltip-light" iconClassName="bb-tooltip-icon-light" light={true} className="m-0 cursor-pointer" label={""} iconname="fa-info">
                    <div className="text-left bb-body-txt"><span>{info}</span></div>
                </Tooltip> : null}
            </h3>
        </div>

        <div className="summary-card-line-0">
            <span className="summary-card-value"><span className="main">{content}</span> {suffix}</span>
            <div className="summary-card-label">measured</div>
        </div>
        {className === 'creative-consumer' ? <img className="phone-icon" src="/images/icons/wifi-phone.svg" alt="" /> : null}
    </div>
}
export const renderFirstCardModal = (data, isModalOpen, closeModal, isCreative = false) => {
    Modal.setAppElement('#root');
    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => closeModal()}
            overlayClassName="bb-modal-overlay"
            bodyOpenClassName="overflow-hidden"
            className="bb-modal-container bb-modal-container-mw-fc report-container"
            ariaHideApp={false}>
            <div className="bb-animate zoomIn d-flex flex-column flex-wrap h-auto summary-card emission-card mx-auto"
                style={{ "transition": "all 1s", transform: "scale(1.5)" }}>
                <div className="d-flex justify-content-between">
                    <h3 className="header-font bb-body-txt d-flex col-12 justify-content-between p-0">Total {isCreative ? "creative" : "deal"} emissions
                        <i className="fas fa-times cursor-pointer fa-2x" onClick={() => closeModal()}></i>
                    </h3>
                </div>

                <div className="summary-card-line-0">
                    <div className="summary-card-value d-flex justify-content-between">
                        <div>
                            <span className="main">{data.total}</span>mt CO<sub>2</sub>
                        </div>
                    </div>
                    <div className="summary-card-label">measured</div>
                </div>
                <HR />
                <div className="summary-card-line-1">
                    <span className="summary-card-value">{data.pre_decarbonisation}mt CO<sub>2</sub></span>
                    <div className="summary-card-label">pre-decarbonisation</div>
                </div>
                <HR />
                <div className="summary-card-line-1">
                    <span className="summary-card-value">{shortFormEmissionNumber(data.carbon_reduction)}mt CO<sub>2</sub>
                    {renderDecarboniseBadge(data)}
                    </span>
                    <div className="summary-card-label">carbon reduction</div>
                </div>
            </div>
        </Modal>
    )

}
export const renderDecarboniseBadge = (data) => {
    let totalPercentage = countCarbonReduction(data)
    return totalPercentage < 0 ? <span className="badge bg-danger ml-1 text-white"><i className="fas fa-caret-up"></i> {totalPercentage}%</span> : <span className="badge bb-bg_green-500 ml-1 text-white"><i className="fas fa-caret-down"></i> {totalPercentage}%</span>
}
export const renderEmissionSumCards = (data, loading, openModal, isCreative = false) => {
    if(loading !== false) return(
        <div>
            <Skeleton className="summary-skeleton m-2" width="180px" height="240px" />
            <Skeleton className="summary-skeleton m-2" width="180px" height="240px" />
            <Skeleton className="summary-skeleton m-2" width="180px" height="240px" />
        </div>
    )
    if(data) {
        let info = "Metrics tons of carbon dioxide equivalent", totalPercentage = countCarbonReduction(data)
        
        return <div className="d-flex flex-wrap">
            <div className="d-flex flex-column flex-wrap h-auto summary-card emission-card">
                <div className="d-flex justify-content-between">
                    <h3 className="header-font bb-body-txt d-flex col-12 justify-content-between p-0">Total {isCreative ? "creative" : "deal"}  emissions
                        <Tooltip default_id="deal-emissions" arrowColor="#4DADC5" tooltipClassName="bb-tooltip-light" iconClassName="bb-tooltip-icon-light" light={true} className="m-0 cursor-pointer" label={""} iconname="fa-info">
                            <div className="text-left bb-body-txt"><span>{info}</span></div>
                        </Tooltip>
                    </h3>
                </div>

                <div className="summary-card-line-0">
                    <div className="summary-card-value d-flex justify-content-between">
                        <div>
                            <span className="main">{shortFormEmissionNumber(data.total)}</span>mt CO<sub>2</sub>e
                        </div>
                        {/* <div>
                            <i className="fas fa-search cursor-pointer" style={{color: "#4DADC5"}} onClick={() => openModal()}></i>
                        </div> */}
                    </div>
                    <div className="summary-card-label">measured</div>
                </div>
                <HR />
                <div className="summary-card-line-1">
                    <span className="summary-card-value">{shortFormEmissionNumber(data.pre_decarbonisation)}mt CO<sub>2</sub>e</span>
                    <div className="summary-card-label">pre-decarbonisation</div>
                </div>
                <HR />
                <div className="summary-card-line-1">
                    <span className="summary-card-value">{shortFormEmissionNumber(data.carbon_reduction)}mt CO<sub>2</sub>e
                        {totalPercentage < 0 ?
                            <span className="badge bg-danger ml-1 text-white"><i className="fas fa-caret-up"></i> {totalPercentage}%</span> :
                            <span className="badge bb-bg_green-500 ml-1 text-white"><i className="fas fa-caret-down"></i> {totalPercentage}%</span>}
                    </span>
                    <div className="summary-card-label">carbon reduction</div>
                </div>
            </div>

            <div className="d-flex flex-column flex-wrap h-auto summary-card emission-card">
                <div className="d-flex justify-content-between">
                    <h3 className="header-font bb-body-txt d-flex col-12 justify-content-between p-0">Actual vs benchmark
                        <Tooltip default_id="actual-emissions" arrowColor="#4DADC5" tooltipClassName="bb-tooltip-light" iconClassName="bb-tooltip-icon-light" light={true} className="m-0 cursor-pointer" label={""} iconname="fa-info">
                            <div className="text-left bb-body-txt"><span>Grams of carbon dioxide measured per impression in comparison to the benchmark emissions.</span></div>
                        </Tooltip>
                    </h3>
                </div>

                <div className="summary-card-line-0">
                    <span className="summary-card-value font-weight-bold"><span className="main">{shortFormEmissionNumber((data.actual || 0)/1000)}</span>g CO<sub>2</sub> per impression <i className={classnames("fas", data.actual < 0 ? "fa-caret-up text-danger" : "fa-caret-down bb-color_green-500")}></i></span>
                    <div className="summary-card-label">measured</div>
                </div>
                <HR />
                <div className="summary-card-line-1">
                    
                    <span className="summary-card-value font-weight-normal">{shortFormEmissionNumber((data.estimated || 0)/1000)}g CO<sub>2</sub> per impression</span>
                    <div className="summary-card-label">benchmark</div>
                </div>
            </div>

            
            <div className="d-flex flex-column flex-wrap h-auto summary-card emission-card">
                <div className="d-flex justify-content-between w-100">
                    <h3 className="header-font bb-body-txt col-11 justify-content-between p-0 text-truncate pr-1" title='Category 1 - Purchased goods and services'>Cat. 1 - Purchased goods and services</h3>
                    <Tooltip default_id="indirect-emissions" arrowColor="#4DADC5" tooltipClassName="bb-tooltip-light" iconClassName="bb-tooltip-icon-light" light={true} className="m-0 cursor-pointer" label={""} iconname="fa-info">
                        <div className="text-left bb-body-txt"><span>Indirect emissions generated by the advertising supply chain.</span></div>
                    </Tooltip>
                </div>

                <div className="summary-card-line-0">
                    <span className="summary-card-value font-weight-normal">{shortFormEmissionNumber(data.media_distribution)}mt CO<sub>2</sub>e</span>
                    <div className="summary-card-label">Media distribution</div>
                </div>
                <HR />
                <div className="summary-card-line-1">
                    <span className="summary-card-value text-black_imp">{shortFormEmissionNumber(data.ad_selection)}mt CO<sub>2</sub>e</span>
                    <div className="summary-card-label">Ad selection</div>
                </div>
                <HR />
                <div className="summary-card-line-1">
                    <span className="summary-card-value text-black_imp">{shortFormEmissionNumber(data.creative_distribution)}mt CO<sub>2</sub>e
                    </span>
                    <div className="summary-card-label">Creative distribution</div>
                </div>
            </div>

                        
            <div className="d-flex flex-column flex-wrap h-auto summary-card emission-card">
                <div className="d-flex justify-content-between w-100">
                    <h3 className="header-font bb-body-txt col-11 justify-content-between p-0 text-truncate pr-1" title='Category 11 - Use of sold products'>Cat. 11 - Use of sold products</h3>
                    <Tooltip default_id="consumer-emissions" arrowColor="#4DADC5" tooltipClassName="bb-tooltip-light" iconClassName="bb-tooltip-icon-light" light={true} className="m-0 cursor-pointer" label={""} iconname="fa-info">
                        <div className="text-left bb-body-txt"><span>Emissions linked to the use of goods by the end users.</span></div>
                    </Tooltip>
                </div>

                <div className="summary-card-line-0">
                    <span className="summary-card-value font-weight-normal">{shortFormEmissionNumber(data.consumer_device)}mt CO<sub>2</sub>e</span>
                    <div className="summary-card-label">Consumer device</div>
                </div>
            </div>
        </div>
    } return renderEmpty();
}
export const renderSubInfoRow = (title, value) => {
    return (
        <div className="d-flex flex-row text-right info-large">
            <div>{title}:</div>
            <div className="ml-3">{value}</div>
        </div>
    )
}
const getPrecentage = (val, total) => {    
    return (((Number(val)/Number(total))) * 100) || 0
}
export const renderChart = (data, publishers) => {
    const wholeTotal = Number(data.media_distribution) + Number(data.ad_selection) + Number(data.creative_distribution) + Number(data.consumer_device) || 0, category1Total = Number(data.media_distribution) + Number(data.ad_selection) + Number(data.creative_distribution)
    let categories = []
    let chartValues = []
    if(category1Total){
        let subCategory = []
        if (data.media_distribution) subCategory.push({
            name: "Media distribution",
            itemStyle: { color: '#66D3FA' },
            percent: getPrecentage(data.media_distribution, category1Total),
            value: data.media_distribution
        })
        if (data.ad_selection) subCategory.push({
            name: "Ad selection",
            itemStyle: { color: '#66D3FA' },
            percent: getPrecentage(data.ad_selection, category1Total),
            value: data.ad_selection
        })
        if (data.creative_distribution) subCategory.push({
            name: "Creative distribution",
            itemStyle: { color: '#66D3FA' },
            percent: getPrecentage(data.creative_distribution, category1Total),
            value: data.creative_distribution
        })
        categories.push({
            name: "Category 1 - Purchased goods and services",
            itemStyle: { color: '#66D3FA' },
            value: category1Total,
            children: subCategory
        },)
    }
    if (data.consumer_device) {
        categories.push({
            name: "Category 11 - Use of sold products",
            itemStyle: { color: '#FFD89B' },
            value: data.consumer_device,
            children: [
                {
                    name: "Consumer device",
                    itemStyle: { color: '#FFD89B' },
                    percent: getPrecentage(data.consumer_device, data.consumer_device),
                    value: data.consumer_device
                }
            ]
        })
    }
    const dataSource = {
        chart: {
            bgColor: "#ffffff",
            borderThickness: "1",
            borderRadius: "10",
            borderAlpha: "100",
            borderColor: "#D9D9D9",
            showBorder: "1",
            caption: "Emissions by source",
            showplotborder: "1",
            plotfillalpha: "60",
            hoverfillcolor: "#E5E5E5",

            theme: "fusion",
            baseFontSize: "12",
            baseFontColor: "#000000",
            baseFontBold: "1",

            captionFontFamily: "Ubuntu",
            baseFont: "Ubuntu",
            valueFont: "Ubuntu",
            legendItemFont: "Ubuntu",
            plottooltext: "<b>$label</b> was <b>$value</b>, which was $percentValue of parent category",
        },
        category: [
            {
                label: wholeTotal ? "Scope 3<br/> categories" : "No data",
                tooltext: "Please hover over a sub-category to see details",
                color: "#ffffff",
                value: wholeTotal,
                category: categories
            }
        ]
    };
    const publishersData = addonDataEmissions(publishers)

    return (
        <>
            <HR />
            <h3 className="bb-sub-header-txt my-3">Emissions by source</h3>
            <CustomEchart width="700px" height="480px" chartClass="mw-fit-content" type="sunburst" dataSource={renderGaugeData("Emissions by source", categories)} />
            <div className='chart-container my-4 pt-2'>
                <CustomEchart
                    type="bar"
                    attentionData={publishers}
                    isEmissions={true} defaultSortEmpty={true} sortData={[
                    { label: <span>Total CO<sub>2</sub>: Low - High</span>, value: "0" },
                    { label: <span>Total CO<sub>2</sub>: High - Low</span>, value: "1" }
                    ]} hasSorting={true} limit={10} vertical={true}  height="400px" dataSource={publishersData} 
chartClass="pt-3"
                />
            </div>
        </>
    )
}
export const renderSDGInfoModal = (isSdgModalInfoOpen, setInofModal) => {
    return (
        <Modal
            isOpen={isSdgModalInfoOpen}
            onRequestClose={() => setInofModal(false)}
            bodyOpenClassName="overflow-hidden"

            overlayClassName="bb-modal-overlay"
            className="bb-modal-container bb-modal-container-decarbonise-info"
            ariaHideApp={false}
            style={{ maxWidth: "550px" }}
        >
            <div className='h-100'>
                <div className="audience-modal-header">
                    <div className="fas fa-times-circle fa-2x cursor-pointer bb-modal-close" onClick={() => setInofModal(false)}></div>
                </div>
                <div className="d-flex flex-wrap justify-content-between slider-card-scroll-curated h-100">
                    <div className="col-sm-12 col-md-7 d-flex pl-5 py-5 flex-column justify-content-between h-100">
                        <div>
                            <h3 className="m-0">Deal decarbonised</h3>
                            <div className="w-100 mt-2 mb-4 min-height_194px">
                                <div className="font-weight-bold my-3 bb-font_12px">Take urgent action to combat climate change and its impacts</div>
                                This denotes changes have been made to the deal to reduce power consumption throughout the supply chain, which in turn reduces CO<sub>2</sub> greenhouse gas emissions.
                            </div>
                        </div>
                        <div className='mt-2'>
                            <p className="font-weight-bold bb-text_small w-100 text-uppercase m-0">DETAILS</p>
                            <div className="w-100 d-flex flex-row mb-2 align-items-center">
                                <img src={"/images/green-project/logos/sdg-circle.png"} alt="SDG Logo" width={33} height={33} />
                                <div className="d-flex flex-column align-self-center ml-2">
                                    <p className="font-weight-bold m-0 bb-text_small ">Sustainable Development Goal</p>
                                    <span className="align-self-start">13 Climate Action</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-5 bm-slider-deal-image align-self-center p-0 pr-5">
                        <div className="position-relative">
                            <img src={"/images/green-project/banners/sdg_icon.png"} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export const renderMEInfoModal = (isEmModalInfoOpen, setInofModal) => {
    return (
        <Modal
            isOpen={isEmModalInfoOpen}
            onRequestClose={() => setInofModal(false)}
            overlayClassName="bb-modal-overlay"
            className="bb-modal-container bb-modal-container-decarbonise-info"
            ariaHideApp={false}
            bodyOpenClassName="overflow-hidden"
        >
            <div className='h-100'>
                <div className="audience-modal-header">
                    <div className="fas fa-times-circle fa-2x cursor-pointer bb-modal-close" onClick={() => setInofModal(false)}></div>
                </div>
                <div className="d-flex flex-wrap justify-content-between slider-card-scroll-curated h-100">
                    <div className="col-sm-12 col-md-7 d-flex pl-5 py-5 flex-column justify-content-between h-100">
                        <div>
                            <h3 className="m-0">Emission measurement</h3>
                            <div className="w-100 my-2 min-height_194px">
                                <div className="font-weight-bold my-3 bb-font_12px">Take urgent action to combat climate change and its impacts</div>
                                This indicates that the usage of creative, media and selected add add-ons supplied within this deal are being or have already been measured for ESG purposes.
                            </div>
                            <div className="w-100 my-4 mb">
                                    Emissions will be always measured when you choose to decarbonise your Deal.
                            </div>
                            
                        </div>
                        <div className='mt-2'>
                            <p className="font-weight-bold bb-text_small w-100 text-uppercase m-0">DETAILS</p>
                            <div className="w-100 d-flex flex-row mb-2 align-items-center">
                                <img src={"/images/green-project/logos/sdg-circle.png"} alt="SDG Logo" width={33} height={33} />
                                <div className="d-flex flex-column align-self-center ml-2">
                                    <p className="font-weight-bold m-0 bb-text_small ">Sustainable Development Goal</p>
                                    <span className="align-self-start">13 Climate Action</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-5 bm-slider-deal-image align-self-center p-0 pr-5">
                        <div className="position-relative">
                            <img src={"/images/green-project/banners/measure_emissions_icon.png"} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export const renderDOOHFormatModal = ({deal, onRequestClose}) => {
    let details = deal.details ? JSON.parse(deal.details) : ''
    return(
        <div className='carousel-container'>

            <div className="d-flex flex-row justify-content-between  pt-3">
                <div className="fas fa-times-circle fa-2x cursor-pointer bb-modal-close" onClick={() => onRequestClose()}></div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="col-sm-12 col-md-7 d-flex flex-wrap pl-sm-5 pb-4 flex-column justify-content-between min-h-400">
                    <div>
                        <h3 className="m-0 py-3">{deal.name}</h3>
                        <p className="font-weight-bold w-100 mt-1 mb-3 bb-text_small">Format Category</p>
                        <div className="w-100 add-ons-description">{parse(deal.description || "")}</div>
                    </div>

                    {details?.length > 0 &&<div>
                        <p className="font-weight-bold bb-text_small w-100 text-uppercase m-0">DETAILS</p>
                        {details.map((detail, idx) =>
                            <div className="w-100 d-flex flex-row border-bottom py-2" key={idx}>
                                <i className={`${detail.icon} fa-2x mr-3 align-self-center`} aria-hidden="true"></i>
                                <div className="d-flex flex-column align-self-center">
                                    <p className="font-weight-bold m-0 bb-text_small ">{detail.label}</p>
                                    <span className="align-self-start">
                                        {detail.value}
                                    </span>
                                </div>
                            </div>)
                        }
                    </div>}
                </div>

                <div className="col-sm-12 col-md-5 bm-slider-deal-image p-0 px-5">
                    <div className="position-relative">
                        <img className=" bm-logo-c-deal-slider deal" src={deal.image || "/images/default_bespoke_card.png"}
                            onError={(e) => e.target.src = "/images/default_bespoke_card.png"}
                            alt="" />
                    </div>
                </div>
            </div>
        </div>)
}
export const downloadLoading = (text = "Downloading...", color = "#e83457", className = "" ) => {
    return (<>
        {text ? <span className='mr-2'>{text}</span> : ""}
        <Spinner width="20" height="20" color={color} type="oval" className={className}/>
    </>)
}

export const CreativeTitle = ({ creative, checkDOOH = false }) => {
    let checkVideo = creative.device === 3 || creative.device === "3"
    return (
        <p className="text-left mb-2 bb-text_small text-break">
            {`${creative.ad_name} `}
            <span className="bb-breadcrumbs-separator">|</span>
            {(checkDOOH || checkVideo) ? null : <>
                {` ${getDeviceName(creative.device)} `}
                <span className="bb-breadcrumbs-separator">|</span>
            </>}
            {` ${creative.ad_type} `}
            <span className="bb-breadcrumbs-separator">|</span>
            {` ${creative.dimension} `}
            {creative.payload_size ? <>
                <span className="bb-breadcrumbs-separator">|</span>
                <span title={creative.payload_size+" bytes"}> {shortFormBytes(creative.payload_size)}</span>
            </>: null}
            {creative.format_type_tier_name ? <>
                <span className="bb-breadcrumbs-separator"> | </span>
                {getFormatTier(creative.format_type_tier_name)}
            </>: null}
        </p>
    )
}

export const renderShareQRModal = (ad) =>{
    return (
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
                <div className='bb-modal-preview text-black'>
                    <Formik enableReinitialize={true} >{({ values }) => (
                        <Form className="p-3 d-flex flex-column">
                            <div className="d-flex flex-row justify-content-between bb-modal-header text-uppercase">
                                <h5 className="font-weight-bold">Share public preview link</h5>
                                <div className="fas fa-times fa-2x cursor-pointer bb-modal-close" onClick={() => onClose()}></div>
                            </div>
                            <div className="content align-self-center">
                                <QrPreviewEmail iniV={ad} creativePage={true} link={`c/${ad._id}`} email={false}/>
                            </div>
                        </Form>
                    )}
                    </Formik>
                </div>
                )
            }
        })
    )
}
export const budsterReminder = (message, className = "") => {
    return <div className={classnames('d-flex align-items-center mb-4 bb-color_gray_imp shadow p-4 bb-animate fadeIn budster-reminder', className)}>
        <img src="/images/icons/budster-head-transparent.png" alt="budster-logo" width={36} height={36} />
        <span className="bb-font_14px ml-2">{message}</span>
    </div>
}
export const renderModal = ({title, onSubmit, content = "", onSubmitText = "Yes", onCancelText = "Cancel" }) =>{
    return (
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className='bb-confirm-box bg-white' style={{ maxWidth: "470px" }}>
                <h4 className="pb-1 ft-title">{title}</h4>
                <div>{content}</div>
                <div className="d-flex flex-row justify-content-center mt-3">
                  <button className="btn bb-color_primary mr-3" onClick={onClose}>{onCancelText}</button>
                  <button className="bb-button mr-3" onClick={() => { onClose(); onSubmit() }}>{onSubmitText}</button>
                </div>
              </div>
            )
          }
        })
      )
}
export const renderInfoModal = ({title, content = "", onSubmitText = "Done" }) =>{
    return (
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className='bb-confirm-box bg-white' style={{ maxWidth: "470px" }}>
                <div className="d-flex justify-content-between">
                    <h4 className="pb-1 ft-title">{title}</h4>
                    <i className="fas fa-times-circle fa-2x cursor-pointer bb-modal-close" onClick={() => onClose()}></i>
                </div>
                <div>{content}</div>
                <div className="d-flex flex-row justify-content-center mt-3">
                  <button className="bb-button mr-3" onClick={() => onClose() }>{onSubmitText}</button>
                </div>
              </div>
            )
          }
        })
      )
}
export const renderImageModal = (c, showDefault) => {
    let image = c.ss ? c.ss : c.content && c.content.length ? c.content[0].imageSrc || c.content[0].src : false
    return(<ImageModal image={image} showDefault={showDefault}/>)
}
export const renderModalApprove = (onSubmit, isAdmin = true) => {
    if(isAdmin){
        renderModal({ title: "Approve creative?", onSubmit, content: "Approved creatives will be prepared to go live and mark production as finished. Did the client express their approval for this creative(s)?", onSubmitText: "Approve" })
    }
    else{
        renderModal({ title: "Approve creative?", onSubmit, content: "Approval will mark production of this creative as finished and let our team know it’s good to go live. Do you want to approve this creative?", onSubmitText: "Approve", onCancelText: "Still reviewing" })
    }
}
export const renderModalDisregard = (onSubmit, isAdmin = true) => {
    if(isAdmin){
    renderModal({ title: "Disregard creative?", onSubmit, content: "Disregarded creatives will not be included in preparations to go live. Did the client express their wish to disregard this creative(s)?", onSubmitText: "Disregard" })
    }
    else{
        renderModal({ title: "Disregard creative?", onSubmit, content: "Disregarding will exclude this creative from preparations to go live. Do you want to disregard this creative?", onSubmitText: "Disregard", onCancelText: "Still reviewing"})
    }
}
export const renderCard = (header, value, newItem = 0, tipDescription = "", iconClassName="bb-color_disabled_imp ", onClick = null, isSelected = false) => {
    return (
        <div className={classnames("bg-white d-flex flex-column flex-wrap text-dark daily-breakdown-cards mo-w-100 m-2 p-2", onClick ? "cursor-pointer" : "", isSelected ? "selected" : "")} onClick={onClick}>
            <h3 className={classnames("header-font d-flex justify-content-between")}>{header}
                {tipDescription ? <Tooltip className="m-0 cursor-pointer" label={""} iconname="fa-info-circle" iconClassName={iconClassName} default_id={header}>
                    <div className="p-2 text-left maxWidth-300"><span>{tipDescription}</span></div>
                </Tooltip> : null}
            </h3>
            <div className="d-flex flex-column flex-grow-1">
                <span className='font-weight-bold'>{value === undefined ? 
                    <Skeleton width="10px" height="3px" /> 
                    : 
                    <AnimatedNumber n={value} />
                }</span>
                <div className="d-flex justify-content-between w-100 align-items-center">
                    <div className={classnames('bb-color_blue-500 bb-font_14px d-flex ', newItem > 0 ? "" : "opacity-none")}>
                        <AnimatedNumber n={newItem} />  <span>&nbsp;new</span>
                    </div>
                    <div className='card-icon bb-bg_tertiary-20 bb-center'>
                        {isSelected ? <i className='fas fa-times text-black-50'></i> : <i className='far fa-eye text-black-50'></i>}
                    </div>
                </div>
            </div>
        </div>
    )
}
export const renderAIAlphaAddon = () => {
    return (<div>
        <div className="px-5 pb-5 pt-4">
            <h3 className="mb-2">AI Alpha</h3>
            <p>
                Spotting the ad is only the first step—your audience must have enough time to view it and fully understand the message. Without it, ads fail to make an impact and waste your budget. <br /><br />
                Here’s how AI Alpha calculates the required attention time and ensures your ads are always in the right place at the right time:
            </p>
            <div className="mt-2 text-center">
                <video controls loop muted playsInline autoPlay style={{ width: "auto", height: "350px" }}>
                    <source src="https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/download/video/BigAds_UnseenAdsWasteYrBudget.mp4" />
                </video>
            </div>
        </div>
    </div>)
}
export const renderCheckBadge = (value, column, styleNone = false) => value[column] ?
    (styleNone ? <span className="pr-2 bb-font_12px">{Number(value[column]).toFixed(1)} mt</span> : <span className="badge bb-bg-tertiary-20 badge-pill p-2 font-weight-normal bb-font_12px">
        <i className="fas fa-check-circle bb-color_green-600 mr-1"></i>{Number(value[column]).toFixed(1)} mt
    </span>) : <span className="bb-color_disabled">-</span>
export const renderEmpty = () => {
    return <div className="mt-2 text-center">No data found</div>
}
export const renderLastUpdate = (days = 2) => <div className='bb-font_13px bb-color_gray_imp'>Last updated: {formatDateDisplay(getOldDays(days))}</div>
export const renderIsDecarboniseIcon = (decarbonise = "off") => {
    if(decarbonise === "on") return <i title="Always on" className="fas fa-check text-success"></i>
    return <i title="Always off" className="fas fa-times text-danger"></i>
}
export const renderDecarboniseTag = (className) => {
    return(<span className={classnames("bb-bg_green-800 decarbonise-tag bb-font_12px", className)}>{decarboniseEyeIcon()}Decarbonised</span>)
}
export const decarboniseEyeIcon = (classNames = "") => {
    return (<svg className={classnames("decarbonise-eye-icon", classNames)} width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.9154 4.64519C12.5973 2.07341 9.98789 0.333374 7 0.333374C4.01211 0.333374 1.40193 2.07463 0.0845702 4.64543C0.0289692 4.75542 0 4.87693 0 5.00017C0 5.12341 0.0289692 5.24493 0.0845702 5.35491C1.40266 7.92669 4.01211 9.66673 7 9.66673C9.98789 9.66673 12.5981 7.92547 13.9154 5.35467C13.971 5.24468 14 5.12317 14 4.99993C14 4.87669 13.971 4.75517 13.9154 4.64519ZM7 8.50006C4.60225 8.50006 2.40405 7.16325 1.21697 5.00005C2.40405 2.83685 4.60201 1.50004 7 1.50004C9.39799 1.50004 11.5959 2.83685 12.783 5.00005C11.5962 7.16325 9.39799 8.50006 7 8.50006Z" fill="#fff" />
        <path d="M6.99998 2.37504C5.5502 2.37504 4.37498 3.55026 4.37498 5.00004C4.37498 6.44982 5.5502 7.62504 6.99998 7.62504C8.44977 7.62504 9.62498 6.44982 9.62498 5.00004C9.62498 3.55026 8.44977 2.37504 6.99998 2.37504ZM7.871 6.16012C7.82972 6.20119 7.78643 6.24427 7.75129 6.27952C7.71964 6.31127 7.6973 6.35043 7.68598 6.39288C7.66999 6.45279 7.65708 6.51333 7.63549 6.57144L7.45142 7.06733C7.30578 7.09909 7.15505 7.11698 6.99998 7.11698V6.82717C7.01787 6.69359 6.91912 6.44337 6.76045 6.2847C6.69695 6.22119 6.66128 6.13504 6.66128 6.04517V5.70636C6.66128 5.58315 6.59491 5.46989 6.48705 5.4103C6.33495 5.32615 6.1186 5.20856 5.97041 5.13394C5.8489 5.07276 5.73649 4.99485 5.63541 4.90372L5.62694 4.8961C5.55465 4.83085 5.49047 4.75714 5.43578 4.67657C5.3365 4.53082 5.17476 4.29108 5.06966 4.13527C5.28633 3.65367 5.67679 3.26691 6.162 3.0568L6.41613 3.18392C6.52876 3.24023 6.66128 3.15841 6.66128 3.03245V2.91285C6.74585 2.89919 6.8319 2.89051 6.91944 2.88723L7.21898 3.18678C7.28514 3.25293 7.28514 3.36016 7.21898 3.42631L7.16934 3.47585L7.05989 3.58529C7.02687 3.61832 7.02687 3.67198 7.05989 3.705L7.10954 3.75465C7.14256 3.78767 7.14256 3.84134 7.10954 3.87436L7.02486 3.95904C7.00896 3.97491 6.98741 3.98381 6.96495 3.98381H6.86979C6.84778 3.98381 6.82661 3.99238 6.81073 4.00783L6.70573 4.10997C6.69286 4.12251 6.6843 4.13881 6.6813 4.15652C6.67829 4.17423 6.68099 4.19244 6.68901 4.20852L6.85402 4.53865C6.88218 4.59496 6.84121 4.66122 6.77834 4.66122H6.71864C6.69822 4.66122 6.67853 4.65382 6.66318 4.64048L6.56495 4.55517C6.54273 4.53588 6.51586 4.52272 6.487 4.51696C6.45815 4.51121 6.42829 4.51307 6.40036 4.52235L6.07044 4.63233C6.04525 4.64073 6.02334 4.65684 6.00782 4.67838C5.9923 4.69993 5.98395 4.72581 5.98396 4.75236C5.98396 4.80031 6.01106 4.84402 6.05393 4.86551L6.1712 4.92415C6.27081 4.974 6.38068 4.99993 6.49203 4.99993C6.60338 4.99993 6.73113 5.28879 6.83074 5.33864H7.53726C7.62713 5.33864 7.71318 5.37431 7.77679 5.43782L7.9217 5.58273C7.98223 5.64329 8.01623 5.72541 8.01622 5.81104C8.0162 5.87592 8.00336 5.94016 7.97844 6.00007C7.95351 6.05997 7.917 6.11437 7.871 6.16012ZM8.7888 5.19321C8.72751 5.17786 8.67406 5.14029 8.63902 5.08768L8.44871 4.80221C8.42086 4.76051 8.406 4.71148 8.406 4.66133C8.406 4.61118 8.42086 4.56216 8.44871 4.52045L8.65606 4.20947C8.68062 4.17274 8.71428 4.14289 8.75387 4.12321L8.89125 4.05451C9.03436 4.33945 9.11692 4.65995 9.11692 5.00004C9.11692 5.09181 9.10909 5.18167 9.09766 5.27037L8.7888 5.19321Z" fill="#fff" />
    </svg>
    )
}
export const decarboniseMeasurementIcon = (classNames = "") => {
    return (<svg className={classnames("measurement-icon", classNames)} width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.30611 10.0217L4.41556 9.13111L9.131 4.41566L10.0216 5.30621C10.435 5.71963 11.1418 5.42684 11.1419 4.84217L11.1419 1.51428C11.1419 1.15183 10.8481 0.858034 10.4856 0.858034L7.15772 0.858032C6.57307 0.858032 6.28026 1.56492 6.69368 1.97834L7.58421 2.86887L2.86876 7.58431L1.97821 6.69376C1.5648 6.28034 0.857929 6.57313 0.85791 7.1578L0.857911 10.4857C0.857912 10.8481 1.15171 11.1419 1.51416 11.1419H4.84205C5.42672 11.142 5.71953 10.4351 5.30611 10.0217Z" fill="#fff" />
        <path d="M9.73702 7.39997C9.10192 7.39997 8.69057 7.69805 8.36762 8.22964C8.30903 8.32607 8.32709 8.45828 8.40882 8.52927L8.75205 8.8274C8.83459 8.89908 8.95202 8.88232 9.01663 8.78959C9.21594 8.50357 9.36378 8.33888 9.67511 8.33888C9.91988 8.33888 10.2227 8.51934 10.2227 8.79125C10.2227 8.9968 10.0745 9.10237 9.83283 9.25759C9.55098 9.4386 9.178 9.66388 9.178 10.2274V10.3166C9.178 10.4375 9.2635 10.5354 9.36896 10.5354H9.94559C10.0511 10.5354 10.1366 10.4375 10.1366 10.3166V10.264C10.1366 9.87337 11.1333 9.8571 11.1333 8.79997C11.1333 8.00387 10.4124 7.39997 9.73702 7.39997ZM9.65728 10.8039C9.35337 10.8039 9.10612 11.0871 9.10612 11.4353C9.10612 11.7834 9.35337 12.0666 9.65728 12.0666C9.96119 12.0666 10.2084 11.7834 10.2084 11.4353C10.2084 11.0871 9.96119 10.8039 9.65728 10.8039Z" fill="#fff" />
    </svg>)
}
export const co2WeightIcon = (classNames = "") => {
    return (<svg className={classNames} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_1661_5784)">
            <path d="M11.8466 17.6965C11.8466 18.3949 12.1517 18.6603 12.637 18.6603C13.1223 18.6603 13.4274 18.3949 13.4274 17.6965V12.3606C13.4274 11.6622 13.1223 11.3968 12.637 11.3968C12.1517 11.3968 11.8466 11.6622 11.8466 12.3606V17.6965Z" fill="#fff" />
            <path fillRule="evenodd" clipRule="evenodd" d="M20.4961 7.20611L23.9193 20.8997C24.3098 22.4611 23.2322 24 21.749 24H2.25137C0.767774 24 -0.309883 22.4611 0.0805858 20.8997L3.50481 7.20611C3.68246 6.49455 4.27543 6.00048 4.95184 6.00048H7.77606C7.60825 5.52939 7.50043 5.02924 7.50043 4.50049C7.50043 2.01517 9.51512 0.000488281 12.0004 0.000488281C14.4858 0.000488281 16.5004 2.01517 16.5004 4.50049C16.5004 5.02924 16.3922 5.52939 16.2248 6.00048H19.049C19.7254 6.00048 20.3179 6.49408 20.4961 7.20611ZM10.5 4.50002C10.5 5.32689 11.1731 6.00002 12 6.00002C12.8268 6.00002 13.5 5.32689 13.5 4.50002C13.5 3.67314 12.8268 3.00002 12 3.00002C11.1731 3.00002 10.5 3.67314 10.5 4.50002ZM9.49264 17.6546C9.49264 19.1631 8.71613 20.0571 7.24632 20.0571C5.77651 20.0571 5 19.1631 5 17.6546V12.4025C5 10.894 5.77651 10 7.24632 10C8.71613 10 9.49264 10.894 9.49264 12.4025V12.7936C9.49264 13.2267 9.20145 13.52 8.7716 13.52C8.34175 13.52 8.05056 13.2267 8.05056 12.7936V12.3048C8.05056 11.6622 7.7455 11.3968 7.28792 11.3968C6.83033 11.3968 6.52528 11.6622 6.52528 12.3048V17.7663C6.52528 18.4089 6.83033 18.6603 7.28792 18.6603C7.7455 18.6603 8.05056 18.4089 8.05056 17.7663V16.9143C8.05056 16.4813 8.34175 16.1879 8.7716 16.1879C9.20145 16.1879 9.49264 16.4673 9.49264 16.9143V17.6546ZM14.9527 17.5987C14.9527 19.1631 14.1346 20.0571 12.637 20.0571C11.1395 20.0571 10.3214 19.1631 10.3214 17.5987V12.4584C10.3214 10.894 11.1395 10 12.637 10C14.1346 10 14.9527 10.894 14.9527 12.4584V17.5987ZM17.0588 19.7708H18.3552C18.6932 19.7708 18.9723 20.0233 18.9723 20.3784C18.9723 20.7263 18.7005 21 18.3552 21H16.4001C16.0409 21 15.7692 20.7263 15.7692 20.3644V20.127C15.7692 19.6647 15.8266 19.2765 15.9858 18.8993C16.1442 18.5238 16.3983 18.1712 16.7734 17.7721L16.7744 17.771C17.1303 17.3986 17.3561 17.1057 17.4938 16.8347C17.6291 16.5684 17.6827 16.3167 17.6827 16.0203C17.6827 15.8105 17.6457 15.6929 17.5983 15.6299C17.559 15.5776 17.4935 15.5384 17.3569 15.5384C17.2286 15.5384 17.1593 15.577 17.1169 15.6294C17.0692 15.6885 17.031 15.7957 17.031 15.9784V16.146C17.031 16.5079 16.7593 16.7816 16.4001 16.7816C16.0409 16.7816 15.7692 16.5079 15.7692 16.146V16.0343C15.7692 15.5045 15.9007 15.0678 16.1833 14.7628C16.4677 14.4558 16.8801 14.3092 17.3846 14.3092C17.889 14.3092 18.3006 14.4557 18.5847 14.7563C18.8676 15.0554 19 15.4818 19 15.9924C19 16.8364 18.6777 17.5337 17.7606 18.5144C17.4641 18.8339 17.29 19.0542 17.1886 19.2428C17.0925 19.4215 17.0595 19.5758 17.0588 19.7708Z" fill="#fff" />
        </g>
        <defs>
            <clipPath id="clip0_1661_5784">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>)
}
export const co2Icon = (className = "") => {
    return <svg className={className} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.11948 7.99094C4.11948 9.12236 3.5371 9.79284 2.43474 9.79284C1.33238 9.79284 0.75 9.12236 0.75 7.99094V4.0519C0.75 2.92047 1.33238 2.25 2.43474 2.25C3.5371 2.25 4.11948 2.92047 4.11948 4.0519V4.34523C4.11948 4.66999 3.90109 4.88999 3.5787 4.88999C3.25631 4.88999 3.03792 4.66999 3.03792 4.34523V3.97857C3.03792 3.49666 2.80913 3.29762 2.46594 3.29762C2.12275 3.29762 1.89396 3.49666 1.89396 3.97857V8.07475C1.89396 8.55665 2.12275 8.74522 2.46594 8.74522C2.80913 8.74522 3.03792 8.55665 3.03792 8.07475V7.4357C3.03792 7.11094 3.25631 6.89094 3.5787 6.89094C3.90109 6.89094 4.11948 7.10046 4.11948 7.4357V7.99094Z" fill="#CCCCCC"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M8.21449 7.94903C8.21449 9.12236 7.60091 9.79284 6.47776 9.79284C5.3546 9.79284 4.74102 9.12236 4.74102 7.94903V4.0938C4.74102 2.92047 5.3546 2.25 6.47776 2.25C7.60091 2.25 8.21449 2.92047 8.21449 4.0938V7.94903ZM5.88498 8.02237C5.88498 8.54617 6.11377 8.74522 6.47776 8.74522C6.84174 8.74522 7.07053 8.54617 7.07053 8.02237V4.02047C7.07053 3.49666 6.84174 3.29762 6.47776 3.29762C6.11377 3.29762 5.88498 3.49666 5.88498 4.02047V8.02237Z" fill="#CCCCCC"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M10.7664 9.5781H9.79406C9.79464 9.43186 9.8194 9.31614 9.89146 9.18214C9.96753 9.04066 10.0981 8.87544 10.3204 8.63581C11.0083 7.90024 11.25 7.37729 11.25 6.7443C11.25 6.36132 11.1507 6.04158 10.9385 5.8172C10.7254 5.59178 10.4168 5.48192 10.0384 5.48192C9.66007 5.48192 9.35076 5.59185 9.13744 5.82209C8.92552 6.05082 8.82689 6.37838 8.82689 6.77572V6.85953C8.82689 7.1309 9.03068 7.3362 9.30007 7.3362C9.56946 7.3362 9.77325 7.1309 9.77325 6.85953V6.73382C9.77325 6.59678 9.80189 6.51639 9.83769 6.47206C9.86944 6.43274 9.92142 6.40382 10.0176 6.40382C10.1202 6.40382 10.1692 6.43323 10.1987 6.47245C10.2343 6.51966 10.262 6.60787 10.262 6.76525C10.262 6.98753 10.2218 7.17628 10.1203 7.37605C10.017 7.5793 9.84776 7.79897 9.58082 8.07822L9.58004 8.07904C9.29875 8.37844 9.10817 8.64284 8.98934 8.9245C8.86999 9.20739 8.82689 9.49849 8.82689 9.84524V10.0233C8.82689 10.2947 9.03068 10.5 9.30007 10.5H10.7664C11.0254 10.5 11.2292 10.2947 11.2292 10.0338C11.2292 9.76749 11.0199 9.5781 10.7664 9.5781Z" fill="#CCCCCC"/>
    </svg>
}
